/* Linda advertorial — scoped JS. Runs only on pages that contain Linda sections. */
(function () {
  if (typeof window === "undefined") return;
  if (!document.querySelector(".la-hero, .la-stats, .la-section")) return;

  // Stats slider nav buttons
  document.querySelectorAll(".la-stats").forEach(function (section) {
    var slider = section.querySelector(".la-stats__slider");
    var prev = section.querySelector(".la-stats__nav__prev");
    var next = section.querySelector(".la-stats__nav__next");
    if (!slider || !prev || !next) return;
    var cardWidth = function () {
      var card = slider.querySelector(".la-stats__card");
      return card ? card.getBoundingClientRect().width + 24 : 320;
    };
    prev.addEventListener("click", function () {
      slider.scrollBy({ left: -cardWidth(), behavior: "smooth" });
    });
    next.addEventListener("click", function () {
      slider.scrollBy({ left: cardWidth(), behavior: "smooth" });
    });
  });

  // Incident slider drag-scroll fallback for mouse users
  document.querySelectorAll(".la-incidents__slider, .la-reviews__slider").forEach(function (slider) {
    var isDown = false;
    var startX = 0;
    var scrollLeft = 0;
    slider.addEventListener("mousedown", function (e) {
      isDown = true;
      slider.classList.add("is-dragging");
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });
    slider.addEventListener("mouseleave", function () {
      isDown = false;
      slider.classList.remove("is-dragging");
    });
    slider.addEventListener("mouseup", function () {
      isDown = false;
      slider.classList.remove("is-dragging");
    });
    slider.addEventListener("mousemove", function (e) {
      if (!isDown) return;
      e.preventDefault();
      var x = e.pageX - slider.offsetLeft;
      var walk = (x - startX) * 1.5;
      slider.scrollLeft = scrollLeft - walk;
    });
  });

  // Sticky CTA appears after user scrolls past the hero
  var sticky = document.querySelector(".la-sticky");
  var stickyAnchor = document.querySelector("[data-sticky-anchor]");
  if (sticky && stickyAnchor) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          sticky.classList.add("is-visible");
        }
      });
    }, { threshold: 0 });
    io.observe(stickyAnchor);
  }

  // Reveal animations now handled via CSS @keyframes — no JS observer needed.
})();
